import { useTranslation } from "react-i18next";
import { CornerDownRight } from "lucide-react";
import { Dropdown } from "components/common/Dropdown";
import { PlanNameChip } from "../PlanNameChip";
import type { PlanMoveRowProps } from "./types";

export const PlanMoveRow = ({
  floorPlanId,
  planName,
  staysInFolderName,
  folderOptions,
  selectedFolderOption,
  isDisabled,
  onMovePlan,
}: PlanMoveRowProps) => {
  const { t } = useTranslation();

  return (
    <li className="group flex min-h-11 items-center justify-between gap-4 border-b border-gray-100 py-1.5 pl-4 pr-3 hover:bg-gray-50">
      <span className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
        <PlanNameChip name={planName} variant="filled" />
        {staysInFolderName !== undefined && (
          <span className="flex items-center gap-1 pl-0.5 text-xs text-gray-500">
            <CornerDownRight size={12} className="flex-shrink-0" />
            {t("smartSurveyor.folders.suggestion.staysIn", {
              name: staysInFolderName,
            })}
          </span>
        )}
      </span>
      <Dropdown<string>
        options={folderOptions}
        value={selectedFolderOption}
        placeholder={
          <span className="text-gray-500">
            {t("smartSurveyor.folders.suggestion.moveTo")}
          </span>
        }
        onChange={(folderOption) => onMovePlan(floorPlanId, folderOption)}
        disabled={isDisabled}
        className="w-44 flex-shrink-0"
        // Borderless until the row is hovered or the button is focused
        buttonClassName="w-full justify-between !border-transparent !bg-transparent group-hover:!border-gray-200 group-hover:!bg-white focus:!border-blue-400"
      />
    </li>
  );
};
